import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SmartFeedColumnMinWidth extends BaseOption {
  static label = "Column Min Width";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      append: "px",
      defaultEmptyValue: 300,
    },
  };

  static defaultValue = 300;

  static canShow(smartFeedType) {
    return smartFeedType === "grid";
  }
}
